// extracted by mini-css-extract-plugin
export default {"timeUnit":"CsDcAkoCvhYg5nFYs891","number":"GDyBemAjR0UMMfJueieE","label":"SJvdTE1SqoNmc5cjx2KO"};